import RedirectUrl from "../components/RedirectUrl";

import { Navigate } from "react-router-dom";
import AdminRoute from "../components/AdminRoute";
import ProtectedRoute from "../components/ProtectedRoute";
import OrderMemories from "../features/admin/submissions/OrderMemories";
import Orders from "../features/admin/submissions/Orders";
import AuthorNameEdit from "../features/book-details/AuthorNameEdit";
import BookFlowLayout from "../features/book-details/BookFlowLayout";
import BookOverview from "../features/book-details/BookOverview";
import DetailsWizard from "../features/book-details/DetailsWizard";
import ApproveSubmission from "../features/book/components/ApproveSubmission";
import ThankYouComponent from "../features/book/components/ThankYouComponent";
import Logout from "../features/logout";
import MemoriesList from "../features/memories/List";
import MemoryEditorPage from "../features/memories/MemoryEditorPage";
import AuthCallBack from "../features/user/Callback";
import Login from "../features/user/Login";

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: <Navigate to="/memories" />,
  },
  {
    path: "/memories",
    element: <ProtectedRoute element={<MemoriesList />} />,
  },
  {
    path: "/memories/new",
    element: <ProtectedRoute element={<MemoryEditorPage />} />,
  },
  {
    path: "/memories/edit/:memoryID",
    element: <ProtectedRoute element={<MemoryEditorPage />} />,
  },
  {
    path: "/book",
    element: <ProtectedRoute element={<BookFlowLayout />} />,
    children: [
      { index: true, element: <Navigate to="overview" replace /> },
      { path: "overview", element: <BookOverview /> },
      { path: "details/:stepSlug", element: <DetailsWizard /> },
      { path: "author-name", element: <AuthorNameEdit /> },
      { path: "review", element: <ApproveSubmission /> },
    ],
  },
  {
    path: "/details",
    element: <Navigate to="/book/details/title" replace />,
  },
  {
    path: "/approve-submission",
    element: <Navigate to="/book/review" replace />,
  },
  // {
  //   path: "/bookcreation",
  //   element: <Navigate to="/submissions" />,
  // },
  // {
  //   path: "/edit-submission",
  //   element: <ProtectedRoute element={<BookEditor />} />,
  // },
  // {
  //   path: "/submissions",
  //   element: <ProtectedRoute element={<BookSubmission />} />,
  // },
  {
    path: "/login-redirect",
    element: isLoggedIn ? (
      <Navigate to="/" />
    ) : (
      <RedirectUrl url={process.env.REACT_APP_lOGIN_URL} />
    ),
  },
  {
    path: "/mystories-matter",
    element: <RedirectUrl url="https://mystoriesmatter.com" />,
  },
  {
    path: "/user",
    element: <Login />,
  },
  {
    path: "/callback",
    element: <AuthCallBack />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/thank-you",
    element: <ThankYouComponent />,
  },
  {
    path: "/admin/submissions",
    element: <AdminRoute element={<Orders />} />,
  },
  {
    path: "/admin/submissions/:id",
    element: <AdminRoute element={<OrderMemories />} />,
  },
  {
    path: "*",
    element: <Navigate to="/memories" />,
  },
];

export default routes;
